<div class="col-md-12 heading" [title]="node_dir" *ngIf="isVisible === true">
    <div class="row">
        <div class="col-md-10">
            <a class="breadcrumb-item" (click)="getObjects(node_dir,'data org')">
                {{dataorg_label}}
            </a>
            <span class="breadcrumb-item" *ngFor="let node of node_dir.split('.'); let i = index;">
                <strong class="slash" *ngIf="i > 0"></strong>
                <span (click)="getObjects(node_dir, node)"
                    *ngIf="node !== 'raw' && node !== 'staged' && node !== 'processed'">{{node}}</span>
                <span (click)="getObjects(node_dir, node)"
                    *ngIf="node === 'raw' || node === 'staged' || node === 'processed'">{{node
                    | titlecase}}</span>
            </span>
        </div>
        <div class="col-md-2 text-right" id="hide_propertupaneBtn" (click)="hideDataOrgPane()"
            *ngIf="parent === 'policy'">
            <img src="assets/images/data-org/property_hide_icon.png" width="22" alt="Hide Data Org pane">
        </div>
    </div>
</div>
<div class="container-fluid" *ngIf="isVisible === true">
    <div class="col-md-12 padding0" id="dataorg_wrapper">
        <dx-scroll-view #scrollviewContainer id="scrollviewContainer">
            <div class="row" *ngIf="!isForPipeline">
                <div class="col-md-3 paddingright0" *ngFor="let folder of folders; let i = index;">
                    <div class="foldercss col-md-12" [ngClass]="{'highlight': selectedIndex === i}"
                        (dblclick)="getNodesFun(folder)" (click)="selectElement(i, folder, 'folder')">
                        <div class="text-center">
                            <img src="assets/images/data-org/folder_icon.png" alt="{{folder.node_dir}}">

                            <p title="{{folder.node_name}}"
                                *ngIf="folder.node_name !== 'raw' && folder.node_name !== 'staged' && folder.node_name !== 'processed'">
                                {{folder.node_name}}</p>
                            <p title="{{folder.node_name}}"
                                *ngIf="folder.node_name === 'raw' || folder.node_name === 'staged' || folder.node_name === 'processed'">{{folder.node_name
                                | titlecase}}</p>
                        </div>
                    </div>

                </div>
                <div class="col-md-3 paddingright0" *ngFor="let file of files; let j = index;">
                    <div class="foldercss col-md-12" [ngClass]="{'highlight': fileSelectedIndex === j}"
                        (click)="selectElement(j, file, 'file')" *ngIf="node_dir !== ''">
                        <div class="text-center">
                            <img src="assets/images/data-org/file.png" alt="{{file.file_name}}">
                            <p title="{{file.fileName}}">{{file.fileName}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="isForPipeline">
                <div class="col-md-1" *ngFor="let folder of folders; let i = index;" >
                    <div class="text-center foldercss" [ngClass]="{'highlight': selectedIndex === i}" (dblclick)="getNodesFun(folder)"
                        (click)="selectElement(i, folder, 'folder')" *ngIf="folder.node_name !== 'staged' && folder.node_name !== 'processed'">
                        <img src="assets/images/data-org/folder_icon.png" alt="{{folder.node_dir}}">
                        <p title="{{folder.node_name}}"
                            *ngIf="folder.node_name === 'raw' && folder.node_name !== 'staged' && folder.node_name !== 'processed'">
                            {{folder.node_name}}</p>
                        <p title="{{folder.node_name}}"
                            *ngIf="folder.node_name !== 'raw' && folder.node_name !== 'staged' && folder.node_name !== 'processed'">
                            {{folder.node_name}}</p>
                    </div>
                </div>
            </div>
        </dx-scroll-view>

    </div>
</div>